import styles from "./Footer.module.css";

export default function Footer() {
  return (
    <footer className={styles.Footer} id="footer">
      <section className={styles.footerContent}>
        <iframe
          className={styles.mapIframe}
          title="google map"
          src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d17936.062133236264!2d74.554318!3d18.656905!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDM5JzI0LjkiTiA3NMKwMzMnMjQuOCJF!5e1!3m2!1sen!2sin!4v1739198519545!5m2!1sen!2sin"
          // width="400"
          // height="300"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>

        <div className={styles.navigation}>
          <h4>Navigation</h4>
          <nav className={styles.navLinks}>
            <li>
              <a href="#home">Home</a>
            </li>
            <li>
              <a href="#about-us">About Us</a>
            </li>
            <li>
              <a href="#trustees-info">Trustees Info</a>
            </li>
            <li>
              <a href="#academics">Academics</a>
            </li>
            <li>
              <a href="#admission">Admission</a>
            </li>
            <li>
              <a href="/terms">Terms</a>
            </li>
            <li>
              <a href="/privacy-policy">Privacy Policy</a>
            </li>
            <li>
              <a href="/hangeshwarPublicSchool">Hangeshwar Public School</a>
            </li>
          </nav>
        </div>
        <div className={styles.contactInfo}>
          <h4>Contact Us</h4>
          <div className={styles.addressDiv}>
            <img src="/icons/address.png" alt="address-icon" />
            <p>
              K. P. Jadhav Highschool and Junior College
              <br /> At post Chimbhale, Tal. Shrigonda,
              <br /> Dist. Ahliyanagar, Pincode:414701
            </p>
          </div>
          <div className={styles.emailDiv}>
            <a href="mailto:kpjadhavjrcollege2016@gmail.com">
              <img src="/icons/email.png" alt="email-icon" />
              kpjadhavjrcollege2016@gmail.com
            </a>
          </div>

          <div className={styles.phoneNumberDiv}>
            <img src="/icons/phonenumber.png" alt="phone number icon" />
            <a href="tel:99758 25357">+91 99758 25357</a>/
            <a href="tel:77983 46550">+91 77983 46550</a>
          </div>
          <div className={styles.workingHoursDiv}>
            <img src="/icons/clock.png" alt="clock-icon" />
            <p>Mon - Sat, 10:00 AM - 4:00 PM</p>
          </div>
        </div>
      </section>

      <div className={styles.attributionsDiv}>
        <h4>Attributions</h4>
        <p>
          <a
            href="https://storyset.com/people"
            target="_blank"
            rel="noreferrer"
          >
            People illustrations by Storyset
          </a>
        </p>
        <p>
          <a target="_blank" href="https://icons8.com" rel="noreferrer">
            icons by Icons8
          </a>
        </p>
      </div>

      <div className={styles.trustDetails}>
        <h4>Trusted By</h4>
        <p>
          Our work is proudly supported by the{" "}
          <strong>Saiseva Bahuuddeshiya Seva Pratishthan</strong> to enhance
          educational opportunities.
        </p>
        <div className={styles.trustLinks}>
          <p>
            Email:{" "}
            <a href="mailto:saisevapratishthan2007@gmail.com">
              saisevapratishthan2007@gmail.com
            </a>
          </p>
        </div>
        <div className={styles.trustLinks}>
          <p>Follow us:</p>
          <a
            href="https://ngodetails.com/india/maharashtra/saiseva-bahuuddeshiya-seva-pratishthan/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/icons/web.png" alt="website icon" />
          </a>
          <a
            href="https://www.facebook.com/people/Saiseva-bahuuddesiya-seva-pratishthan-chimbhale/100068104385869/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/icons/facebook.png" alt="facebook icon" />
          </a>
        </div>
      </div>

      <div className={styles.creatorName}>
        <h4>Developed By</h4>
        <p>© 2025 K. P. Jadhav High School & Junior College</p>
        <p>
          Designed & Developed by{" "}
          <a
            href="https://gayatri--takawale.web.app/"
            target="_blank"
            rel="noreferrer"
          >
            Gayatri Takawale
          </a>
        </p>
      </div>
      {/* 
        <div className={styles.legalLinks}>
            <Link to="/terms">Terms & Conditions </Link> | 
            <Link to="/privacy-policy"> Privacy Policy</Link>
        </div> */}
    </footer>
  );
}
